import React, { useEffect, useState } from 'react';
import { 
    IStackItemStyles, 
    Stack, 
    StackItem,
} from '@fluentui/react';
import DatePickerComponent from '../date-picker/date-picker.component';
import TimePickerComponent from '../time-picker/time-picker.component';
import moment from 'moment';

const stackItemStyles : IStackItemStyles = {
    root: {
        width: '50%',
    },
};

const dateFormat : string = "YYYY-MM-DD HH:mm:ss";
const shortDateFormat : string = `YYYY-MM-DD`;
const shortTimeFormat: string = `HH:mm`;

interface IDateTimePickerProps {
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
};

const DateTimePickerComponent = (props: IDateTimePickerProps) => {
    const [dateValue, setDateValue] = useState<string>(props.value ? moment(props.value, dateFormat).format(shortDateFormat) : ``);
    const [timeValue, setTimeValue] = useState<string>(props.value ? moment(props.value, dateFormat).format(shortTimeFormat) : `00:00`);

    useEffect(() => {
        if (dateValue && timeValue) {
            let date : Date = moment(dateValue, shortDateFormat).toDate();
            const hours : number = parseInt(timeValue.split(':')[0]);
            const minutes : number = parseInt(timeValue.split(':')[1]);
            date.setHours(hours, minutes);
            props.onChange(moment(date).format(dateFormat));
        }
    }, [dateValue, timeValue]);

    const onChangeDate = (date: string) : void => {
        setDateValue(date);
    };

    const onChangeTime = (time: string) : void => {
        setTimeValue(time);
    };

    return (
        <Stack horizontal={true}>
            <StackItem styles={stackItemStyles}>
                <DatePickerComponent
                    disabled={props.disabled}
                    value={dateValue}
                    onChange={onChangeDate} />
            </StackItem>
            <StackItem styles={stackItemStyles}>
                <TimePickerComponent
                    disabled={props.disabled}
                    value={timeValue}
                    onChange={onChangeTime} />
            </StackItem>
        </Stack>
    );
};

export default DateTimePickerComponent;
